import logo from "./logo.svg";
import logo2 from "./logo2.svg";
import banner1 from "./banner-1.png";
import bannervideo from "./Banner-Video.mp4";
import homepageBg1 from "./home-bg-1.png";
import CarbonRemoval from "./Carbon-Removal.svg";
import BiocharSoilEnhancement from "./Biochar-Soil-Enhancement.svg";
import WaterIntelligence from "./Water-Intelligence.svg";
import CircularManufacturing from "./Circular-Manufacturing.svg";
import AtmosphereAirQualityEngineerin from "./Atmosphere-Air-Quality-Engineering.svg";
import AccelTRACKLogo from "./Accel-TRACK-logo.svg";
import HydroTRACELogo from "./HydroTRACE-logo.svg";
import AtmosPODLogo from "./AtmosPOD-logo.svg";
import BioForgeLogo from "./BioForge-logo.svg";
import AccelSupplyLogo from "./Accel-supply-logo.svg";
import AccelSupplyLogo2 from "./AccelSupplylogo2.svg";
import AccelALERTLogo from "./Accel-ALERT-logo.svg";
import AccelALERTLogo2 from "./AccelALERT.svg";

import accel1innovation from "./accel1-innovation-1.png";
import BiocharSoilEnhancement2 from "./BiocharSoilEnhancement2.png";
import HydroTRACEDeployment from "./HydroTRACE-Deployment.png";
import VisionImpactImg from "./vision-impact-img.png";
import VisionImpactImgMobile from "./vision-impact-img-mobile.png";
import Hamburger from "./hamburger.svg";
import aproch from "./aproch.png";

import Pledge1 from "./Pledge-1.png";
import Pledge2 from "./Pledge-2.png";
import Pledge3 from "./Pledge-3.png";
import Pledge4 from "./Pledge-4.png";
import Pledge5 from "./Pledge-5.png";

import ClimateContract from "./green-pledge-page-bg-4-img.png";
import thumbteam1 from "./thumb-team-1.png";
import thumbteam2 from "./thumb-team-2.png";
import thumbteam3 from "./thumb-team-3.png";
import thumbteam4 from "./thumb-team-4.png";
import thumbteam5 from "./thumb-team-5.png";
import thumbteam6 from "./thumb-team-6.png";
import thumbteam7 from "./thumb-team-7.png";
import thumbteam8 from "./thumb-team-8.png";
import team1 from "./team-1.png";
import team2 from "./team-2.png";
import team3 from "./team-3.png";
import team4 from "./team-4.png";
import team5 from "./team-5.png";
import team6 from "./team-6.png";
import team7 from "./team-7.png";
import team8 from "./team-8.png";

import profileicon from "./profile-icon.svg";
import locationicon from "./location-icon.svg";
import linkedinicon from "./linkedin-icon.svg";
import leadershipbanner from "./leadership-banner.png";
import leadershipmobilebanner from "./leadership-banner-mobile.png";
import careerbanner from "./careerbanner.png";
import careerbanner2 from "./Career-img2.png";

import fb from "./FB-Blue.svg";
import insta from "./Insta-Blue.svg";
import linkedin from "./Linkedin_Blue.svg";
import x from "./X-Blue.svg";
import Smartercircle from "./Smarter-circle.png";

import bioforgeimg1 from "./bioforge-img-1.png";
import bioforgeimg2 from "./bioforge-img-2.png";
import bioforgeimg3 from "./bioforge-img-3.png";
import bioforgeimg4 from "./bioforge-img-4.png";
import bioforgeimg5 from "./bioforge-img-5.png";
import bioforgeimg6 from "./bioforge-img-6.png";
import DeploymentModels from "./DeploymentModels.png";

import blogthumb1 from "./Listed-Companies-2-400x250.jpg";
import blogthumb2 from "./blog-aust-400x250.jpg";
import blogthumb3 from "./Tracys-Odyssey-Blog-Img-400x250.jpg";
import blogthumb4 from "./How-Can-Carbon-Accounting-Help-Companies-Meet-Emissions-Standards-2-400x250.webp";
import blogthumb5 from "./ESG-Integration-in-Energy-Management-Leveraging-Sustainability-for-Long-Term-Success-2-400x250.webp";
import blogthumb6 from "./Energy-Management-Best-Practices-for-Sustainable-Growth-400x250.webp";
import blogthumb7 from "./Leveraging-Sustainable-Supply-Chain-Operations-for-Competitive-Advantage-400x250.webp";
import blogthumb8 from "./The-Importance-Of-Corporate-Social-Responsibility-In-Green-Finance-2-400x250.webp";
import blogthumb9 from "./A-Comprehensive-Guide-To-Green-Insurance-Products-2-400x250.webp";
import blogthumb10 from "./How-to-Embed-Sustainability-into-Your-Digital-Transformation-Strategy-2-400x250.webp";
// import blogthumb11 from "./What-is-ESG-and-why-is-it-important-for-Businesses-and-Investors-2-400x250.webp";
// import blogthumb12 from "./blog-aust-400x250.jpg";

// import CarbonRemoval from "./home-bg-1.png";
// import BiocharSoilEnhancement from "./home-bg-1.png";
// import WaterIntelligence from "./home-bg-1.png";
// import CircularManufacturing from "./home-bg-1.png";
// import AtmosphereAirQualityEngineerin from "./home-bg-1.png";

import DeploymentModels1 from "./Deployment-Models-1.svg";
import DeploymentModels2 from "./Deployment-Models-2.svg";
import DeploymentModels3 from "./Deployment-Models-3.svg";
import DeploymentModels4 from "./Deployment-Models-4.svg";

import co2 from "./co2.png";
import biomass from "./biomass.png";
import land from "./land.png";
import water from "./water.png";
import jobs from "./jobs.png";

import Verra from "./Verra.png";
import Sylvera from "./Sylvera.png";
import Fromwaste from "./Fromwaste.png";
import SaiBhaskarReddy from "./Sai-Bhaskar-Reddy.png";

import Featurework from "./Feature-work.png";
import Featurework_1 from "./Featurework_1.png";
import Featurework_2 from "./Featurework_2.png";

import cc1 from "./cc-1.svg";
import cc2 from "./cc-2.svg";
import cc3 from "./cc-3.svg";
import cc4 from "./cc-4.svg";
import cc5 from "./cc-5.svg";
import cc6 from "./cc-6.svg";
import cc7 from "./cc-7.svg";
import cc8 from "./cc-8.svg";

import accelsupply_cc1 from "./as-cc-1.svg";
import accelsupply_cc2 from "./as-cc-2.svg";
import accelsupply_cc3 from "./as-cc-3.svg";
import accelsupply_cc4 from "./as-cc-4.svg";
import accelsupply_cc5 from "./as-cc-5.svg";
import accelsupply_cc6 from "./as-cc-6.svg";
import accelsupply_cc7 from "./as-cc-7.svg";

import df1 from "./df-1.svg";
import df2 from "./df-2.svg";
import df3 from "./df-3.svg";
import df4 from "./df-4.svg";
import df5 from "./df-5.svg";

import IntegratesSensors1 from "./Integrates-Sensors-1.svg";
import IntegratesSensors2 from "./Integrates-Sensors-2.svg";
import IntegratesSensors3 from "./Integrates-Sensors-3.svg";
import IntegratesSensors4 from "./Integrates-Sensors-4.svg";
import IntegratesSensors5 from "./Integrates-Sensors-5.svg";

import AccelALERt2 from "./AccelALERt-2.png";
import AccelALERT4 from "./AccelALERT-4.png";
import AccelALERT4a from "./AccelALERT4a.png";
import GlobalStandards from "./Global-Standards.png";
import IntegrationsIntelligence from "./Integrations-Intelligence.png";

import ListedCompanies2 from "./Listed-Companies-2.jpg";
import AccelTrack1 from "./acceltrack-bg-3-img-1.png";
import AccelTrack2 from "./acceltrack-bg-4-img-1.png";
import AccelTrack3 from "./AccelTrack3b.png";

import AcceltabImg1 from "./AcceltabImg1.png";
import AcceltabImg2 from "./AcceltabImg2.png";

import PurposeLed from "./Purpose-Led.svg";
import PlatformThinking from "./Platform-Thinking.svg";
import ScienceDriven from "./Science-Driven.svg";
import ExecutionObsessed from "./Execution-Obsessed.svg";

// blogsdetilas page images start
// import ListedCompanies2 from "./Listed-Companies-2.jpg";
import AustraliPassesLandmarkClimate from "./Australi-Passes-Landmark-Climate.jpg";
import TracysOdysseyBlog from "./Tracys-Odyssey-Blog.jpg";
import CarbonAccountingHelpCompanies from "./Carbon-Accounting-Help-Companies-Meet-Emissions-Standards-2.jpg";
import ESG from "./ESG-Integration-in-Energy-Management-Leveraging-Sustainability-for-Long-Term-Success-2.jpg";
import EnergyManagment from "./Energy-Management-Best-Practices-for-Sustainable-Growth.jpg";
import LeveragingSustainable from "./Leveraging-Sustainable-Supply-Chain-Operations-for-Competitive-Advantage.jpg";
import CorporateSocial from "./The-Importance-Of-Corporate-Social-Responsibility-In-Green-Finance-2.jpg";
import ComprehensiveGuide from "./A-Comprehensive-Guide-To-Green-Insurance-Products-2.jpg";
import DigitalTransformation from "./How-to-Embed-Sustainability-into-Your-Digital-Transformation-Strategy-2.jpg";
import ESGBusinessesandInvestors from "./What-is-ESG-and-why-is-it-important-for-Businesses-and-Investors-2.jpg";

// blogs detilas page images ends

// latest news starts

// latest news thumbline images
import app22_2025 from "./app22_2025.jpg";
import app7_2025 from "./app22_2025.jpg";
import accelalert from "./AccelALERT-ln-400x250.jpg";
import PanaNewsImg from "./Pana-News-Img-400x250.jpg";
import latestnews from "./Latest-News-Img-2-400x250.jpg";
import oct1_2024 from "./oct1_2024.jpg";
import aug19_2024 from "./aug19_2024.jpg";
import Top100 from "./Top-100-400x250.jpg";
import mar21_2024 from "./mar21_2024.jpg";
import ESGReporting from "./Pioneering-ESG-Reporting-A-New-Era-Unveiled-with-AccelTRACK-400x250.png";

// lates news banner images
import rrlatestnews from "./rr-latestnews.jpg"; //1st b
import Climatelatestnews from "./Climate-latest-news.jpg"; //2 b
import latestnewsbanner from "./latest-news-banner_image_3.jpg"; //3 b
import panabanner from "./Pana-News-Img.jpg"; //4b
//  5 b not there
import bannerimgoct7 from "./banner_image_oct_1_2024.jpg"; //6 b
import Balvindermangat from "./banner_image_aug_19_2024.jpg"; //7 b
import PromisingTech from "./banner_image_jun_16_2024.jpg"; //8 b
import bedrockbanner from "./banner_image_mar_21_2024.jpg"; // 9 b
import pionerringbanner from "./banner_image_feb_9_2024.png"; //10 b

import contactbanner2 from "./Contact-banner-2.png";

// lates news ends

import latestthumb1 from "./app22_2025.jpg";
import latestthumb2 from "./app7_2025.jpg";
import latestthumb3 from "./AccelALERT-ln-400x250.jpg";
import latestthumb4 from "./Pana-News-Img-400x250.jpg";
import latestthumb5 from "./Latest-News-Img-2-400x250.jpg";
import latestthumb6 from "./zain-logo-1.jpg";
import latestthumb7 from "./Balvinder-Mangat-Image-400x250.jpg";
import latestthumb8 from "./Top-100-400x250.jpg";
import latestthumb9 from "./Forge-Strategic-Alliance-400x250.jpg";
import latestthumb10 from "./Pioneering-ESG-Reporting-A-New-Era-Unveiled-with-AccelTRACK-400x250.png";
import wendyBanner from "./wendy-banner.jpeg";
import eventsthumbline from "./Event-Thumbnail-1-1280x720.jpg";
import newsthumb1 from "./blog-thumb-1.png";

import blogthumb1a from "./blogthumb1a.jpg";
import latestthumb1a from "./ListedCompanies2a.jpg";
import ListedCompanies2a from "./latestthumb1a.jpg";
import Stayupdated1 from "./app22_2025.jpg";
import Stayupdated2 from "./Stayupdated2d.jpg"; //1st b

import innovationthumb from "./innovationthumb.jpg";

import cloudImage from "./cloud.png";
import droneImage from "./drone.gif";
import outcomes_img from "./outcomes-img.png";

import mim_1 from "./mim_1.svg";
import mim_2 from "./mim_2.svg";
import mim_3 from "./mim_3.svg";
import mim_4 from "./mim_4.svg";
import mim_5 from "./mim_5.svg";
import mim_6 from "./mim_6.svg";

import intelligence_1 from "./intelligence-img-1.png";
import intelligence_2 from "./intelligence-img-2.png";
import intelligence_3 from "./intelligence-img-3.png";
import intelligence_4 from "./intelligence-img-4.png";
import intelligence_5 from "./intelligence-img-5.png";
import intelligence_6 from "./intelligence-img-6.png";
import intelligence_7 from "./intelligence-img-7.png";

import vishalgupta from "./vishalgupta.png";
import NoniGonzalez from "./NoniGonzalez.png";
import TracyPaddock from "./TracyPaddock.png";

import Wendy from "./Wendy.png";
import Wendythumb from "./Wendy-thumb.png";
import PratibhaChauhan from "./Pratibha-Chauhan.png";
import PratibhaChauhanthumb from "./Pratibha-Chauhan-thumb.png";

import mrvimg1 from "./mrv-img-1.png";
import mrvimg2 from "./mrv-img-2.png";
import mrvimg3 from "./mrv-img-3.png";

import JacquesGuichard from "./Jacques-Guichard.png";

import aim_1 from "./aim_1.svg";
import aim_2 from "./aim_2.svg";
import aim_3 from "./aim_3.svg";
import aim_4 from "./aim_4.svg";
import aim_5 from "./aim_5.svg";

import AtmosPOD_Deployment_Models from "./AtmosPOD_Deployment_Models.png";

import AtmosPOD_Architecture_img1 from "./AtmosPOD-Architecture-img1.png";
import AtmosPOD_Architecture_img2 from "./AtmosPOD-Architecture-img2.png";
import AtmosPOD_Architecture_img3 from "./AtmosPOD-Architecture-img3.png";

import wc1 from "./wc-1.png";
import wc2 from "./wc-2.png";
import wc3 from "./wc-3.png";
import wc4 from "./wc-4.png";
import wc1_1 from "./wc1-1.png";
import wc2_1 from "./wc2-1.png";
import wc3_1 from "./wc3-1.png";
import wc4_1 from "./wc4-1.png";
import AtmosPOD_intelligence_1 from "./AtmosPOD_intelligence-img-1.png";
import AtmosPOD_intelligence_2 from "./AtmosPOD_intelligence-img-2.png";
import AtmosPOD_intelligence_3 from "./AtmosPOD_intelligence-img-3.png";
import AtmosPOD_intelligence_4 from "./AtmosPOD_intelligence-img-4.png";
import AtmosPOD_intelligence_5 from "./AtmosPOD_intelligence-img-5.png";
import Pratibha from "./Pratibha.jpg";
import SaiBhaskarReddy2 from "./Sai-Bhaskar-Reddy-2.png";
import SaiBhaskarReddy3 from "./Sai-Bhaskar-Reddy-3.png";
import SaiBhaskarReddy4 from "./Sai-Bhaskar-Reddy-4.png";

import Biocharculture from "./pdf/Biocharculture.pdf";
import BiocharSpecificationTesting from "./pdf/Biochar-Specification-and-Testing.pdf";

export const assets = {
  Biocharculture,
  BiocharSpecificationTesting,

  SaiBhaskarReddy4,
  SaiBhaskarReddy3,
  SaiBhaskarReddy2,
  wc1,
  wc2,
  wc3,
  wc4,
  wc1_1,
  wc2_1,
  wc3_1,
  wc4_1,
  Pratibha,
  AtmosPOD_intelligence_1,
  AtmosPOD_intelligence_2,
  AtmosPOD_intelligence_3,
  AtmosPOD_intelligence_4,
  AtmosPOD_intelligence_5,

  AtmosPOD_Architecture_img1,
  AtmosPOD_Architecture_img2,
  AtmosPOD_Architecture_img3,
  AtmosPOD_Deployment_Models,
  aim_1,
  aim_2,
  aim_3,
  aim_4,
  aim_5,
  JacquesGuichard,
  mrvimg1,
  mrvimg2,
  mrvimg3,
  Wendy,
  Wendythumb,
  PratibhaChauhan,
  PratibhaChauhanthumb,

  vishalgupta,
  NoniGonzalez,
  TracyPaddock,

  intelligence_1,
  intelligence_2,
  intelligence_3,
  intelligence_4,
  intelligence_5,
  intelligence_6,
  intelligence_7,
  mim_1,
  mim_2,
  mim_3,
  mim_4,
  mim_5,
  mim_6,
  outcomes_img,
  cloudImage,
  droneImage,
  innovationthumb,
  Stayupdated1,
  Stayupdated2,
  latestthumb1a,
  blogthumb1a,
  ListedCompanies2a,
  newsthumb1,
  eventsthumbline,
  latestthumb1,
  latestthumb2,
  latestthumb3,
  latestthumb4,
  latestthumb5,
  latestthumb6,
  latestthumb7,
  latestthumb8,
  latestthumb9,
  latestthumb10,
  wendyBanner,
  // latest news
  app22_2025,
  app7_2025,
  accelalert,
  PanaNewsImg,
  latestnews,
  oct1_2024,
  aug19_2024,
  Top100,
  mar21_2024,
  ESGReporting,

  // banner images of latest news
  rrlatestnews,
  Climatelatestnews,
  latestnewsbanner,
  panabanner,
  bannerimgoct7,
  Balvindermangat,
  PromisingTech,
  bedrockbanner,
  pionerringbanner,
  // ends

  // blogs details calign
  // ListedCompanies2,
  AustraliPassesLandmarkClimate,
  TracysOdysseyBlog,
  CarbonAccountingHelpCompanies,
  ESG,
  EnergyManagment,
  LeveragingSustainable,
  CorporateSocial,
  ComprehensiveGuide,
  DigitalTransformation,
  ESGBusinessesandInvestors,
  // ends

  PurposeLed,
  PlatformThinking,
  ScienceDriven,
  ExecutionObsessed,

  AcceltabImg1,
  AcceltabImg2,
  AccelTrack3,
  AccelTrack1,
  AccelTrack2,
  ListedCompanies2,
  careerbanner,
  careerbanner2,
  GlobalStandards,
  accelsupply_cc1,
  accelsupply_cc2,
  accelsupply_cc3,
  accelsupply_cc4,
  accelsupply_cc5,
  accelsupply_cc6,
  accelsupply_cc7,
  IntegrationsIntelligence,

  AccelSupplyLogo2,
  bannervideo,
  AccelALERt2,
  AccelALERT4,
  AccelALERT4a,

  IntegratesSensors1,
  IntegratesSensors2,
  IntegratesSensors3,
  IntegratesSensors4,
  IntegratesSensors5,

  df1,
  df2,
  df3,
  df4,
  df5,

  cc1,
  cc2,
  cc3,
  cc4,
  cc5,
  cc6,
  cc7,
  cc8,

  Featurework,
  Featurework_1,
  Featurework_2,
  SaiBhaskarReddy,
  Verra,
  Sylvera,
  Fromwaste,
  logo,
  logo2,
  banner1,
  homepageBg1,
  CarbonRemoval,
  BiocharSoilEnhancement,
  WaterIntelligence,
  CircularManufacturing,
  AtmosphereAirQualityEngineerin,
  AccelTRACKLogo,
  HydroTRACELogo,
  AtmosPODLogo,
  BioForgeLogo,
  AccelSupplyLogo,

  AccelALERTLogo,
  AccelALERTLogo2,
  accel1innovation,
  BiocharSoilEnhancement2,
  HydroTRACEDeployment,
  VisionImpactImg,
  VisionImpactImgMobile,
  Hamburger,
  aproch,
  Pledge1,
  Pledge2,
  Pledge3,
  Pledge4,
  Pledge5,
  ClimateContract,
  thumbteam1,
  thumbteam2,
  thumbteam3,
  thumbteam4,
  thumbteam5,
  thumbteam6,
  thumbteam7,
  thumbteam8,
  team1,
  team2,
  team3,
  team4,
  team5,
  team6,
  team7,
  team8,
  profileicon,
  locationicon,
  linkedinicon,

  contactbanner2,
  leadershipbanner,
  leadershipmobilebanner,
  fb,
  insta,
  x,
  linkedin,
  Smartercircle,
  bioforgeimg1,
  bioforgeimg2,
  bioforgeimg3,
  bioforgeimg4,
  bioforgeimg5,
  bioforgeimg6,
  DeploymentModels,

  DeploymentModels1,
  DeploymentModels2,
  DeploymentModels3,
  DeploymentModels4,

  blogthumb1,
  blogthumb2,
  blogthumb3,
  blogthumb4,
  blogthumb5,
  blogthumb6,
  blogthumb7,
  blogthumb8,
  blogthumb9,
  blogthumb10,

  co2,

  biomass,
  land,
  water,
  jobs,
};
